var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 388.476,
    height: 79.688,
    viewBox: "0 0 388.476 79.688",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41245",
    "data-name": "Group 41245",
    transform: "translate(0.499 -34.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M1478.418-12762.111s2.319,29.693,41.129,10.4,89.6-12.179,114.184-25.312,5.359-27.222-15.833-27.222-55.944,18.234-8.008,22.946,185.739,8.193,199.752-4.1c10.59-9.288,7.375-17.419,21.355-22.071s32.2-4.851,34.564,3.461-6.787,12.669-25.1,29.782-19.445,31.172-48.16,38.667-66.7-8.687-66.7-8.687",
    transform: "translate(-1478.418 12845.281)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M2.592,0C19.578,0,19.655,10.4,19.655,10.4S19.578,20.739,2.592,20.739A2.592,2.592,0,0,1,0,18.147V2.592A2.592,2.592,0,0,1,2.592,0Z",
    transform: "translate(227.102 90.975)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1477",
    "data-name": "Rectangle 1477",
    width: 10.369,
    height: 3.456,
    rx: 1.728,
    transform: "translate(221.054 96.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1478",
    "data-name": "Rectangle 1478",
    width: 10.369,
    height: 3.456,
    rx: 1.728,
    transform: "translate(221.054 103.073)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(165.821 89.778)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(171.821 99.778)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(180.821 99.778)",
    fill: "#f6f7f9"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cord.8fd14a5e8fc6bc91c9e8b33819c19618.svg";